import { PromptSuggestion, SuggestedPromptsSection } from '../types'

export const GLOBAL_PROMPTS_TO_SHOW = 3

export const GLOBAL_PROMPTS_POOL: PromptSuggestion[] = [
  { label: 'What is IR and how is it calculated?' },
  { label: 'How do I set up a MaxDiff question?' },
  { label: 'How do logic conditions work in aytm?' },
  { label: 'How do I run a multilingual study?' },
  { label: 'What question types does aytm support?' },
  { label: 'How do I use Skipper Autocode?' },
  { label: 'How do I work with Virtual Questions (VQs)?' },
  { label: 'What is Conversation AI and when should I use it?' },
  { label: 'How does the Ad Testing Simulator work?' },
  { label: 'How does Verbatim Skipper Translation work?' },
  { label: 'When should I use open-ended vs. closed-ended questions?' },
  { label: 'How do I run an e-commerce test?' },
  { label: 'How do I set up an ad effectiveness study?' },
  { label: 'What can Skipper help me with?' },
  { label: 'How to add funds?' },
  { label: 'Help me with smartloops' }
]

export const GLOBAL_SUGGESTED_PROMPTS_SECTION: SuggestedPromptsSection = {
  label: 'Available everywhere',
  prompts: GLOBAL_PROMPTS_POOL
}

// Fisher–Yates partial sample. Returns up to `count` distinct items from `pool`.
// Non-destructive — the original array is not mutated.
export function pickRandomPrompts(pool: PromptSuggestion[], count: number): PromptSuggestion[] {
  if (count <= 0 || pool.length === 0) {
    return []
  }
  const take = Math.min(count, pool.length)
  const working = pool.slice()
  for (let i = 0; i < take; i += 1) {
    const j = i + Math.floor(Math.random() * (working.length - i))
    const tmp = working[i]
    working[i] = working[j]
    working[j] = tmp
  }
  return working.slice(0, take)
}
